
  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {CountingVo} from "@/views/components/Counting/CountingVo";

  @Component({
    name: "Counting",
    filters: {
      weightFixed(value, num: number) {
        if (value === 0) {
          return '0'
        }
        if (value > 1000) {
          return (value / 1000).toFixed(2) + '吨'
        }
        return value.toFixed(num)
      }
    }
  })

  export default class extends Vue {
    @Prop() private isscanforoutboundGetoff: boolean;

    @Prop({
      default: {
        totalCount: 0,
        totalWeight: 0,
        currentCount: 0,
        allCount: 0
      }
    })

    private vo!: CountingVo;

    private checkIsScanForOutBoundGetOffWeight(): boolean {
      return this.isscanforoutboundGetoff && this.vo.totalWeight > 1000
    }

    private checkIsScanForOutBoundGetOff(): boolean {
      if (this.isscanforoutboundGetoff) {
        let s = this.vo.currentCount + "/" + this.vo.allCount;
        if (s.length >= 6)
          return true
      }
      return false
    }

    private getOffSet(): number {
      if (this.vo.showProgress) {
        return 0;
      }
      return 6
    }
  }
